export default "__VITE_ASSET__TL7O4U6$__"